import { Box, Button } from '@mui/material'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { tokens } from '../../theme'
import Header from '../../components/Header'
import { useTheme } from '@mui/material'
import React from "react"
import { useState, useEffect } from "react"
import { useNavigate } from 'react-router-dom'

import { ptBR as ptBRGrid } from '@mui/x-data-grid'

import * as Constants from '../../constants'

function arraysEqual(a1, a2) {
  /* WARNING: arrays must not contain {objects} or behavior may be undefined */
  return JSON.stringify(a1) === JSON.stringify(a2)
}

const Devices = () => {
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)
  const [rows, setRows] = useState([])
  const [selectedRows, setSelectedRows] = useState([])

  let navigate = useNavigate()

  const editMultiple = (e) => {
    if (selectedRows.length === 0) {
      alert('Selecione pelo menos um dispositivo para gerenciar.')
      return
    }
    navigate('/device/' + selectedRows.map((row) => row.id).join(','))
  }

  const handleRowClick = (e) => {
    navigate('/device/' + e.row.id)
  }

  const handleSetOwner = (e) => {
    if (selectedRows.length === 0) {
      alert(
        'Selecione pelo menos um dispositivo para atribuir um novo proprietário.'
      )
      return
    }

    var str = ''
    selectedRows.forEach((row) => {
      console.log(row)
      str += row.id + ','
    })

    navigate('/set-owner-device/' + str)
  }

  const fetchDevices = () => {
    fetch(Constants.HOST + '/devices', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        data = data.data
        let newRows = []
        data.devices.forEach((device) => {
          let json_data = JSON.parse(device.json_data)
          newRows.push({
            id: device.imei,
            manufacturer: json_data.manufacturer,
            model: json_data.model,
            android: json_data.release,
            phone: json_data.phone,
            owners: device.name ? device.name : 'Nenhum',
            status: device.online ? 'Online' : 'Offline',
          })
        })
        if (!arraysEqual(rows, newRows)) setRows(newRows)
      })
      .catch((error) => {
        console.log(error)
      })
  }
  useEffect(() => {
    fetchDevices()
  }, [])

  const columns = [
    { field: 'id', headerName: 'IMEI', flex: 1 },
    {
      field: 'manufacturer',
      headerName: 'Marca',
      flex: 1,
      cellClassName: 'name-column--cell',
    },
    { field: 'model', headerName: 'Modelo', flex: 1 },
    {
      field: 'android',
      headerName: 'Android',
      type: 'number',
      headerAlign: 'left',
      align: 'left',
      flex: 1,
    },
    { field: 'owners', headerName: 'Proprietário', flex: 1 },
    { field: 'status', headerName: 'Status', flex: 1 },
  ]

  return (
    <Box m="20px">
      <Header title="Dispositivos" subtitle="Lista de dispositivos" />
      <Box
        m="20px 0"
        gridColumn="span 6"
        justifyContent="flex-end"
        display={{ xs: 'none', md: 'flex' }}
      >
        <Button
          variant="contained"
          color="warning"
          onClick={editMultiple}
          sx={{ mr: '5px' }}
        >
          Gerenciar selecionados
        </Button>
        <Button variant="contained" color="success" onClick={handleSetOwner}>
          Alterar proprietário (dispositivos selecionados)
        </Button>
      </Box>

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          '& .MuiDataGrid-root': {
            border: 'none',
          },
          '& .MuiDataGrid-cell': {
            borderBottom: 'none',
          },
          '& .name-column--cell': {
            color: colors.greenAccent[300],
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: colors.blueAccent[700],
            borderBottom: 'none',
          },
          '& .MuiDataGrid-virtualScroller': {
            backgroundColor: colors.primary[400],
          },
          '& .MuiDataGrid-footerContainer': {
            borderTop: 'none',
            backgroundColor: colors.blueAccent[700],
          },
          '& .MuiCheckbox-root': {
            color: `${colors.greenAccent[200]} !important`,
          },
          '& .MuiDataGrid-toolbarContainer .MuiButton-text': {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          checkboxSelection
          rows={rows ? rows : []}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          onRowClick={handleRowClick}
          localeText={ptBRGrid.components.MuiDataGrid.defaultProps.localeText}
          getRowClassName={(params) => {
            if (params.row.status === 'Offline')
              return 'MuiDataGrid-row--offline'
            else return 'MuiDataGrid-row--online'
          }}
          disableSelectionOnClick
          onSelectionModelChange={(ids) =>
            setSelectedRows(ids.map((id) => rows.find((row) => row.id === id)))
          }
        />
      </Box>
    </Box>
  )
}

export default Devices
